import throttle from 'lodash-es/throttle';
import { useEffect, useRef } from 'react';
import { AffirmContainer, StyledFinancingOptionText } from './styles';

import { useHistory } from 'react-router';
import { isLocationAvailableWithAffirm } from '../../api/Utils/affirmUtils';
import { waitForVariable } from '../../utilities/browserUtils';

const refreshAffirm = throttle(() => {
  try {
    window.affirm.ui.refresh();
  } catch (e) {
    console.error(e);
  }
}, 500);

const FinancingOptionText = ({
  productType,
  amount,
  shouldRefresh,
  resortLocation,
  textDecoration,
  fontSize,
  fontWeight,
  lineHeight,
  color
}) => {
  const rateContainer = useRef();
  const shouldEnableAffirm = isLocationAvailableWithAffirm(resortLocation);
  const history = useHistory();

  useEffect(() => {
    return () => {
      if (history?.action === 'POP') window.affirm?.ui?.modal?.close();
    };
  }, [history]);

  useEffect(() => {
    waitForVariable('affirm').then(() => refreshAffirm());
  }, [shouldRefresh]);

  useEffect(() => {
    if (shouldEnableAffirm) {
      const affirmCont = rateContainer.current;
      const setListeners = event => {
        const { target } = event;
        target.parentElement.querySelector('.affirm-modal-trigger').click();
      };
      // As for now this is the only way we can emulate the behavior in production
      affirmCont?.addEventListener('click', setListeners);

      return () => {
        if (rateContainer) {
          affirmCont?.removeEventListener('click', setListeners);
        }
      };
    }
  }, [rateContainer, shouldEnableAffirm]);

  if (!shouldEnableAffirm) return null;

  return (
    <>
      <AffirmContainer ref={rateContainer}>
        <StyledFinancingOptionText
          m={0}
          className="affirm-as-low-as"
          data-page-type={productType}
          data-amount={amount}
          textDecoration={textDecoration}
          fontSize={fontSize}
          fontWeight={fontWeight}
          lineHeight={lineHeight}
          color={color}
        />
      </AffirmContainer>
    </>
  );
};

export default FinancingOptionText;
